;(function () {
  'use strict'

  angular
    .module('pub.drop.waitlist.service', [])
    .factory('DropsWaitlistService', DropsWaitlistService)

  /** @ngInject */
  function DropsWaitlistService($http, $q, API) {
    function list(id, start, limit, sort) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'publisher/drops/' +
            id +
            '/waitlists/users?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      list: list,
    }
  }
})()
